interface RowStylesHook {
  rowStyle: React.CSSProperties,
}

export const useRowStyles = ({ justifyContent }: React.CSSProperties):RowStylesHook => ({
  rowStyle: {
    justifyContent,
  },
});
